<script>
export default {
    name: "InvoiceDetails",

    data () {
        return {
            invoiceDetails: {},
            invoiceLines: [],
            invoiceNo:this.$router.currentRoute.params.invoiceNo,
            showModal:false,
            invoicedocuments:[],
            invoicedocument:{
                docName:"",
                }
        };
    },

    computed: {
        subTotalLines() {

        if(!this.invoiceLines.length) return 0;

        return this.invoiceLines.map(line => line.total ? parseFloat(line.total) : 0).reduce((sum, total) => sum + total);
      },

      grandTotalLines() {

        if(!this.invoiceLines.length) return 0;

        return this.invoiceLines.map(line => parseFloat(line.grandTotal)).reduce((sum, gTotal) => sum + gTotal);
      },

      taxLines() {

        if(!this.invoiceLines.length) return 0;

        return this.invoiceLines
            .map( line => (parseFloat(line.tax)/100) * parseFloat(line.total) )
                .reduce( (sum, tax) => sum + tax );
      },

      discountLines() {

        if(!this.invoiceLines.length) return 0;

        return this.invoiceLines
            .map( line => (parseFloat(line.discount)/100) * parseFloat(line.total) )
                .reduce( (sum, discount) => sum + discount );
      }
    },

    mounted() {
        this.fetchInvoiceDetails();
        this.fetchInvoiceDocuments();
    },

    methods: {

        fetchInvoiceDetails() {
            this.$root.loading = true;
            this.invoiceNo=this.$router.currentRoute.params.invoiceNo;
            this.$accountsHttp.get(`SupplierInvoice/PostedSpecificInvoice?InvoiceNo=${this.$router.currentRoute.params.invoiceNo}`).then(response => {
                this.invoiceDetails = response.data.length ? response.data[0] : {};
            }).then(() => {
                this.fetchInvoiceLines();
                this.$root.loading = false;
            }).catch(() => this.$root.loading = false);
        }, 
        fetchInvoiceDocuments() {
          this.$root.loading = true;
          this.$accountsHttp.get(`SupplierInvoice/GetInvoiceDocument?InvoiceNo=${this.$router.currentRoute.params.invoiceNo}`).then(response => {
            this.invoicedocuments = response.data;
           if(this.invoicedocuments.length>0){
            this.invoicedocument=this.invoicedocuments[0];
           
           }
          
            this.$root.loading = false;
          }).catch(() => { this.$root.loading = false; });
        }, 
        fetchspecificInvoiceDocuments() {
          this.$root.loading = true;
          this.$accountsHttp.get(`Files/GetSpecificSupplierInvoiceDocument?InvoiceNo=${this.$router.currentRoute.params.invoiceNo}`).then(response => {
            this.invoicedocument = response.data;
            this.$root.loading = false;
          }).catch(() => { this.$root.loading = false; });
        },

        fetchInvoiceLines() {
            this.$accountsHttp.get(`SupplierInvoice/postedInvoiceDetails?InvoiceNo=${this.invoiceDetails.invoiceNo}&UserName=${this.invoiceDetails.userName}`)
                .then(response => {
                    this.invoiceLines = response.data;
                });
        },

        printReceipt(url) {
            window.open(url, 'Invoice Preview', 'left=200,top=200,width=500,height=700,tollbar=0,scrollbars=1,status=0,resizable=1');
        },
    },
      components: {
        'view-file': () => import('./modals/ViewFile.vue')
    },
}
</script>
<template>
    <tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <div class="flex w-full">
            <h5 class="flex-1 font-medium">Invoice Details</h5>
            <div class="flex flex-1 justify-end"></div>
          </div>
        </template>
        <template v-slot:card-body>
            <tail-address-header></tail-address-header>
            <div class="flex justify-center p-2">
                <h3 class="text-center font-bold text-blue-400 border-b-2 border-blue-400">SUPPLIER INVOICE</h3>
            </div>
            <div class="flex justify-center p-2">
                <h4 class="font-semibold text-blue-600">{{ invoiceDetails.supplier }},</h4>
            </div>
            <div class="flex flex-row w-full p-1 bg-blue-200">
                <div class="flex-1">
                    <h4 class="text-center font-bold">Date: {{ invoiceDetails.txnDate | dateFormat }}</h4>
                </div>
                <div class="flex-1">
                   <h4 class="text-center font-bold">Invoice No: {{ invoiceDetails.invoiceNo }}</h4> 
                </div>
                <div class="flex-1">
                    <h4 class="text-center font-bold">Ext Ref: {{ invoiceDetails.extRef }}</h4>
                </div>
                <div class="flex-1">
                    <h4 class="text-center font-bold">GRN Ref: {{ invoiceDetails.grnRef }}</h4>
                </div>
                <div class="flex-1">
                    <h4 class="text-center font-bold">LPO Ref: {{ invoiceDetails.lpoRefNo }}</h4>
                </div>
                 
            </div> <div class="flex flex-row w-full p-1 bg-blue-200">
                <div class="flex-1">
                    <h4 class="text-center font-bold">KRA Pin No: {{ invoiceDetails.piN_No }}</h4>
                </div>
                <div class="flex-1">
                   <h4 class="text-center font-bold">KRA Cu No: {{ invoiceDetails.kracuno }}</h4> 
                </div>
                <div class="flex-1">
                    <h4 class="text-center font-bold">KRA Invoice No : {{ invoiceDetails.krainvoiceno }}</h4>
                </div>
                
                 
            </div>
            <div class="w-full mt-2">
                <table class="table table-striped">
                    <thead class="bg-blue-500 text-sm text-white">
                        <tr>
                            <th class="p-tiny">Item</th>
                            <th class="p-tiny">Description</th>
                            <th class="p-tiny">LPO Qty</th>
                            <th class="p-tiny">GRN Qty</th>
                            <th class="p-tiny">Qty</th>
                            <th class="p-tiny">Bonus</th>
                            <th class="p-tiny">Price</th>
                            <th class="p-tiny">Discount</th>
                            <th class="p-tiny">Tax</th>
                            <th class="p-tiny">Grand Total</th>
                        </tr>
                    </thead>
                    <tbody class="text-xs">
                        <tr v-for="(invLine, index) in invoiceLines" :key="index">
                            <td class="p-tiny">{{ invLine.itemName }}</td>
                            <td class="p-tiny">{{ invLine.description }}</td>
                            <td class="p-tiny">{{ invLine.orderedQty }}</td>
                            <td class="p-tiny">{{ invLine.grnQty }}</td>
                            <td class="p-tiny">{{ invLine.qty }}</td>
                            <td class="p-tiny">{{ invLine.bonus }}</td>
                            <td class="p-tiny">{{ invLine.unitPrice | numberFormat }}</td>
                            <td class="p-tiny">{{ invLine.discount | numberFormat }}</td>
                            <td class="p-tiny">{{ invLine.tax | numberFormat }}</td>
                            <td class="p-tiny">{{ invLine.grandTotal | numberFormat }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex flex-wrap w-full my-2 p-2 border-2 bg-gray-200">
              <div class="flex-1 flex justify-center"><b>Sub Total: </b><span class="font-bold text-blue-400 ml-1"> {{ subTotalLines | numberFormat }}</span></div>
              <div class="flex-1 flex justify-center"><b>Tax: </b> <span class="font-bold text-blue-400 ml-1"> {{ taxLines | numberFormat }}</span></div>
              <div class="flex-1 flex justify-center"><b>Discount: </b><span class="font-bold text-blue-400 ml-1"> {{ discountLines | numberFormat }}</span></div>
              <div class="flex-1 flex justify-center"><b>Grand Total: </b><span class="font-bold text-blue-400 ml-1"> {{ grandTotalLines | numberFormat }}</span></div>
            </div>
        </template>
        <template v-slot:card-footer>
           <div class="w-full text-right">
        <button
                                @click.prevent="showModal = true" v-if="invoicedocument.docName.length>1"
                                class="btn-sm text-sm bg-green-500 rounded text-white mr-6">
                                    <i class="fa fa-eye"></i> View Document</button>   
                            <view-file 
                                :showModal="showModal"
                                :file="invoicedocument"
                                :InvoiceNo="invoiceNo"
                                @closeModal="showModal=false"
                            />
                           <router-link :to="{ name: `suppliers-dashboard.invoice-list.index` }" class="btn-sm btn-danger text-sm rounded mr-6"><i class="fa fa-caret-left"></i> Back</router-link>
             <button class="btn-sm text-sm btn-primary rounded" 
                    @click.prevent="printReceipt(`/suppliers-dashboard/invoice-list/print/${invoiceNo}`)">
                        <i class="fa fa-print"></i> Preview</button>
                        
           </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
